module.exports = __webpack_public_path__ + "resources/img/img_tibero4_jp.0a42873f023c2e80a2a2ced291e8e6e1.png";